import type { ContentPost } from 'api/new-analytics/types';
import { PseudoPostType } from 'constants/post';
import { contentPostToPseudoPostType } from './contentPostType';

export function getContentPostPreviewImageUrl(
  post: ContentPost,
): string | null {
  const previewMediaUrl = post.preview?.media_url?.trim();
  if (previewMediaUrl) {
    return previewMediaUrl;
  }

  const firstMedia = post.media?.[0];
  if (!firstMedia) {
    return null;
  }

  const pseudoType = contentPostToPseudoPostType(post);
  const isDocumentPost =
    firstMedia.type?.toLowerCase() === 'document' ||
    pseudoType === PseudoPostType.Document;

  if (isDocumentPost) {
    return null;
  }

  const isVideoMedia =
    firstMedia.type === 'video' ||
    pseudoType === PseudoPostType.Video ||
    pseudoType === PseudoPostType.Reel;

  if (isVideoMedia) {
    return firstMedia.thumbnail_url?.trim() || firstMedia.url?.trim() || null;
  }

  return firstMedia.url?.trim() || firstMedia.thumbnail_url?.trim() || null;
}
